// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-area {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
  background: var(--bg-primary);
  display: flex;
  flex-direction: column;
}

.editor-pane { display: none; }
.editor-pane.active {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.editor-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
  color: var(--text-muted);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/EditorArea.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA,eAAe,aAAa,EAAE;AAC9B;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".editor-area {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  position: relative;\n  background: var(--bg-primary);\n  display: flex;\n  flex-direction: column;\n}\n\n.editor-pane { display: none; }\n.editor-pane.active {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.editor-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 16px;\n  color: var(--text-muted);\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
